/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let BulbO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M679.211008 668.442624V535.202816c0-74.149888-80.678912-151.204864-170.665984-151.204864-89.98912 0-170.667008 77.056-170.667008 151.204864v133.239808h341.332992z m56.889344-133.239808v190.128128H280.988672V535.20384c0-101.547008 101.880832-208.094208 227.556352-208.094208 125.67552 0 227.555328 106.5472 227.555328 208.094208zM508.545024 99.55328c15.70816 0 28.443648 12.735488 28.443648 28.444672v56.88832c0 15.710208-12.734464 28.444672-28.443648 28.444672-15.710208 0-28.444672-12.734464-28.444672-28.444672v-56.88832c0-15.709184 12.734464-28.444672 28.444672-28.444672z m170.665984 56.889344c13.604864 7.85408 18.266112 25.250816 10.412032 38.85568l-28.444672 49.266688c-7.85408 13.604864-25.25184 18.266112-38.85568 10.412032-13.604864-7.855104-18.266112-25.25184-10.412032-38.856704l28.444672-49.266688c7.85408-13.604864 25.25184-18.266112 38.85568-10.411008z m137.341952 113.77664c11.108352 11.109376 11.108352 29.118464 0 40.226816l-40.226816 40.226816c-11.107328 11.108352-29.11744 11.108352-40.225792 0-11.108352-11.108352-11.108352-29.118464 0-40.226816l40.225792-40.225792c11.108352-11.108352 29.118464-11.108352 40.226816 0zM224.100352 895.998976c0-15.709184 12.734464-28.444672 28.444672-28.444672h512c15.70816 0 28.443648 12.735488 28.443648 28.444672s-12.734464 28.444672-28.443648 28.444672h-512c-15.710208 0-28.444672-12.735488-28.444672-28.444672z m106.156032-739.555328c13.604864-7.855104 31.000576-3.193856 38.85568 10.411008l28.444672 49.266688c7.85408 13.604864 3.192832 31.0016-10.412032 38.856704-13.604864 7.85408-31.000576 3.192832-38.85568-10.412032l-28.444672-49.266688c-7.85408-13.604864-3.192832-31.0016 10.412032-38.85568z m-122.81856 113.77664c11.108352-11.107328 29.118464-11.107328 40.226816 0l40.225792 40.226816c11.108352 11.108352 11.108352 29.118464 0 40.226816-11.108352 11.108352-29.11744 11.108352-40.225792 0l-40.226816-40.226816c-11.108352-11.108352-11.108352-29.11744 0-40.225792z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

BulbO.defaultProps = {
  size: 18,
};

BulbO = React.memo ? React.memo(BulbO) : BulbO;

export default BulbO;
